import React, { useEffect, useState, useCallback, useRef } from "react";
import SubNav from "../../../Shared/SubNav";
import { useLocation, useNavigate } from "react-router-dom";
import socket from "../../../context/socket";
import { debounce } from "lodash";
import { Button } from "react-bootstrap";
import AddChildrensModal from "../../Modals/AddChildrensModal";
import { format } from "date-fns";
import Cookies from "js-cookie";
import moment from "moment";
import { FaTrash } from "react-icons/fa";
import { MdOutlineCancel } from "react-icons/md";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import { fetchClientData } from "../../../redux/client/clientSlice";

import { BounceLoader, ClimbingBoxLoader, FadeLoader } from "react-spinners";
import DeleteChWarningModal from "./DeleteChWarningModal";
import Swal from "sweetalert2";
import { capitalizeText, validateText } from "../../../utils/inputsValidation";
import Skeleton from "react-loading-skeleton";
import api from "../../../utils/api";
import ProgressBarTimer from "./ProgressBarTimer";

const FinancialPlan = ({ isDarkMode }) => {
  const location = useLocation();
  const currentUrl = location.pathname
  const roomId = new URLSearchParams(window.location.search).get("clientId");
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);

  const prevState = useRef({});
  // State for financial plan details
  const [name, setName] = useState("");
  const [city, setCity] = useState("");
  const [maritalStatus, setMaritalStatus] = useState("");

  const [spouseName, setSpouseName] = useState("");
  const [company, setCompany] = useState("");
  const [spouseCompany, setSpouseCompany] = useState("");
  const [work, setWork] = useState("");
  const [spouseWork, setSpouseWork] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [spouseJobTitle, setSpouseJobTitle] = useState("");
  // console.log("workwork",work,company,jobTitle);
  const [isFirmName, setIsFirmName] = useState("");
  const [isSpouseFirmName, setIsSpouseFirmName] = useState("");
  const [isConsultant, setIsConsultant] = useState("");
  const [isSpouseConsultant, setIsSpouseConsultant] = useState("");
  const [isRetiredYear, setIsRetiredYear] = useState("");

  const [isSpouseRetiredYear, setIsSpouseRetiredYear] = useState("");


  // State to store children information
  const [children, setChildren] = useState([]);
  const dispatch = useDispatch();
  const {
    clientData,
    loading: clientLoading,
    error: clientError,
  } = useSelector((state) => state.client);


  useEffect(() => {
    dispatch(fetchClientData(roomId));
  }, [dispatch, roomId]);




  useEffect(() => {
    if (clientData) {
      // Setting basic details
      setName(clientData.referred_as);
      setCity(clientData.city);
      setMaritalStatus(clientData.marital_status);
      setSpouseName(clientData.spouse_name);

      setCompany(clientData.profession_org);
      setSpouseCompany(clientData?.spouseCompany)

      setJobTitle(clientData.profession_designation);
      setSpouseJobTitle(clientData?.spouseJobTitle);

      setWork(clientData.profession);
      setSpouseWork(clientData?.spouseWork);

      setIsFirmName(clientData.firm_name);
      setIsSpouseFirmName(clientData.isSpouseFirmName);

      setIsConsultant(clientData.consultant);
      setIsSpouseConsultant(clientData.isSpouseConsultant);

      setIsRetiredYear(clientData.retiredYear);
      setIsSpouseRetiredYear(clientData.isSpouseRetiredYear);

      // Safeguard against undefined or null children
      if (Array.isArray(clientData.children)) {
        // console.log(clientData.children);
        const formattedChildren = clientData.children.map((child) => ({
          ...child,
          // dob: moment(child.dob).format("DD-MM-YYYY"),
        }));
        // console.log("formattedChildren", formattedChildren);
        setChildren(formattedChildren);
      } else {
        // If children are undefined or not an array, handle it
        setChildren([]);
      }
    }
  }, [clientData]);


  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  // Debounced function to emit data
  const sendDataToServer = useCallback(
    debounce((data) => {
      // console.log("data", data);
      socket.emit("message", { room: roomId, data });
    }, 500),
    [roomId]
  );

  useEffect(() => {
    sendDataToServer({
      name,
      city,
      maritalStatus,
      spouseName,
      company,
      jobTitle,
      isFirmName,
      isRetiredYear,
      isConsultant,
      children,
      work,
      spouseWork,
      spouseCompany,
      spouseJobTitle,
      isSpouseFirmName,
      isSpouseRetiredYear,
      isSpouseConsultant,

    });
  }, [
    name,
    city,
    maritalStatus,
    spouseName,
    company,
    jobTitle,
    children,
    work,
    isFirmName,
    isRetiredYear,
    isConsultant,
    sendDataToServer,
    spouseWork,
    spouseJobTitle,
    spouseCompany,
    isSpouseFirmName,
    isSpouseRetiredYear,
    isSpouseConsultant

  ]);

  useEffect(() => {
    if (maritalStatus === '') {
      setSpouseName('')
    }
    else if (maritalStatus !== 'married') {
      setSpouseName('')
    }
    if (children) {
      // console.log("children",children);
    }
  }, [maritalStatus, children]);

  // console.log("roomId",currentUrl,"?clientId=",roomId);
  const handleNext = () => {
    // const nextUrl = "/financial-better?clientId=" + roomId;
      const nextUrl = "/my-cash-flow?clientId=" + roomId;
    const nextUrl2 = "/my-cash-flow";

    const isChildren = children.some((ch) => !ch.name || !ch.dob);

    if (!name) {
      Swal.fire({
        // icon: 'warning',
        // title: 'Missing Information',
        text: 'Please enter the referred to as.',
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'swal-confirm-btn',
        },
      });
      return;
    }

    // console.log("work",name,work,spouseName);

    if (
      !maritalStatus ||
      (maritalStatus === "married" && !spouseName) || // Spouse name required if married
      !work ||
      isChildren
    ) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Information',
        text: 'Please fill fields on this page.',
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'swal-confirm-btn',
        },
      });
      return;
    }

    Swal.fire({
      title: 'Warning',
      text: 'Are you sure? You should ideally spend more time with your client here.',
      confirmButtonText: 'OK',
      customClass: {
        confirmButton: 'swal-confirm-btn',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        api.post("advisor/save_user_about_3", {
          _id: String(roomId),
          referred_as: name,
          marital_status: maritalStatus,
          city: city,
          spouse_name: spouseName,
          profession: work,
          profession_org: company,
          profession_designation: jobTitle,
          children: children.map((child) => ({
            ...child,
            name: child.name ? child.name : child.name,
          })),
          firm_name: isFirmName,
          work: work,
          spouseWork: spouseWork,
          consultant: isConsultant,
          retiredYear: isRetiredYear,
          company_name: company,
          spouseJobTitle,
          spouseCompany,
          isSpouseFirmName,
          isSpouseRetiredYear,
          isSpouseConsultant,
        })
          .then((response) => {
            console.log("Message saved:", response.data.children, nextUrl2);

            socket.emit("navigate", { room: roomId, url: nextUrl2 });
            navigate(nextUrl);
          })
          .catch((error) => {
            console.error("Error saving message:", error);
          });

      }

    });

  };

  const saveUserAbout = async () => {

    const isChildren = children.some((ch) => !ch.name || !ch.dob);


    // if (!name) {
    //   Swal.fire({
    //     // icon: 'warning',
    //     // title: 'Missing Information',
    //     text: 'Please enter the referred to as.',
    //     confirmButtonText: 'OK',
    //     customClass: {
    //       confirmButton: 'swal-confirm-btn',
    //     },
    //   });
    //   return;
    // }

    // // console.log("work",name,work,spouseName);

    // if (

    //   !maritalStatus ||
    //   (maritalStatus === "married" && !spouseName) || // Spouse name required if married
    //   !work ||
    //   isChildren
    // ) {
    //   Swal.fire({
    //     icon: 'warning',
    //     title: 'Missing Information',
    //     text: 'Please fill fields on this page.',
    //     confirmButtonText: 'OK',
    //     customClass: {
    //       confirmButton: 'swal-confirm-btn',
    //     },
    //   });
    //   return;
    // }

    api
      .post("advisor/save_user_about_3", {
        _id: String(roomId),
        referred_as: name,
        city: city,
        marital_status: maritalStatus,
        spouse_name: spouseName,
        profession: work,
        profession_org: company,
        profession_designation: jobTitle,
        children: children.map((child) => ({
          ...child,
          name: child.name ? (child.name) : child.name,
        })),
        firm_name: isFirmName,
        work: work,
        spouseWork: spouseWork,
        consultant: isConsultant,
        retiredYear: isRetiredYear,
        company_name: company,
        spouseJobTitle,
        spouseCompany,
        isSpouseFirmName,
        isSpouseRetiredYear,
        isSpouseConsultant
      })
      .then((response) => {
        console.log("Message saved:", response.data.children);
        // Cookies.set("children", JSON.stringify(response.data.children));
        // Emit the navigation event after saving the message
      })
      .catch((error) => {
        console.error("Error saving message:", error);
      });
  }





  const handleBack = () => {
    const prevUrl = "/dream?clientId=" + roomId;
    const prevUrl2 = "/dream";

    // console.log("here");
    socket.emit("navigate", { room: roomId, url: prevUrl2 });
    navigate(prevUrl);
  };

  const handleAdditionalChildrenChange = (index, field) => (event) => {
    let value = event.target.value;

    console.log("handleAdditionalChildrenChange", field, value);

    // Apply capitalizeText only when the field is "name"
    if (field === "name") {
      value = capitalizeText(value);
    }

    // Ensure immutability by cloning the previous state
    setChildren((prevChildren) => {
      return prevChildren.map((child, i) =>
        i === index ? { ...child, [field]: value } : child
      );
    });
  };


  const handleAddMoreChild = () => {
    setChildren((prevChildren) => [...prevChildren, { name: "", dob: "" }]);
  };



  const [showModal, setShowModal] = useState(false);
  const [index, setIndex] = useState(null);


  const handleDeleteChildren = (index) => {
    // console.log(id,"dddddd");
    setIndex(index)
    setShowModal(true);
  };
  const handleConfirmDelete = async () => {
    setChildren((prevChildren) => prevChildren.filter((_, i) => i !== index));
    setShowModal(false);
    saveUserAbout();
  };


  // if (clientLoading) {
  //   return (
  //     <div
  //       className="d-flex justify-content-center align-items-center"
  //       style={{ minHeight: "300px" }}>
  //       <FadeLoader color="#23674B" size={50} />
  //     </div>
  //   );
  // }
  const isMobile = window.innerWidth <= 768;
  if (clientLoading) {
    return (
      <div className="container py-4">
        {/* Title Skeleton */}
        {/* <Skeleton height={40}   style={{ marginBottom: 20 }} /> */}

        <div className="row g-5 align-items-start">
          {/* Left: Large Profile Circle */}
          <div className="col-12 col-md-6 text-center">
            <Skeleton
              count={4}
              style={{ marginBottom: 20 }}
              width={isMobile ? 300 : 500}
              height={isMobile ? 60 : 60}
            />
          </div>

          {/* Right: Content blocks */}
          <div className="col-12 col-md-6">
            {[1, 2, 3].map((item) => (
              <div className="d-flex align-items-start gap-3 mb-4" key={item}>
                <Skeleton
                  circle
                  width={50}
                  height={50}
                />
                <Skeleton
                  width={isMobile ? 300 : 500}
                  height={100}
                />
              </div>
            ))}
          </div>
        </div>

        <Skeleton height={60} width={'100%'} style={{ marginBottom: 20, borderRadius: 40 }} />
      </div>
    );
  }
  const calculateAge = (dob) => moment().diff(moment(dob), "years");

  if (clientError) {
    return <div>Error loading client data</div>;
  }



  return (
    <>
      <DeleteChWarningModal showModal={showModal} setShowModal={setShowModal} handleConfirmDelete={handleConfirmDelete} children={children} />
      <div className="container minht">
        <div className="row ge-5 pe-md-5">

          <div className="d-flex flex-column justify-content-center">
            <h3 className="text-black  fw-normal mb-4 text-center">
              Before we start, we would like to get to know you better
            </h3>

            <div className="card shadow mb-4 p-2 custom-finincal-plan-md-75  mx-auto" style={{ border: "0px", backgroundColor: isDarkMode ? "" : "#F4F6FF" }}>
              <p className=" fw-medium text-center clrgreen "  >
                We know how important money is today and trying to achieve meaningful financial involves
                a considerable amount of hard work and sacrifice.
              </p>
            </div>
          </div>




          <div className="col-lg-6 col-md-12 flex flex-col items-center p-6" >
            <div className="text-center w-100">
              <h2 className=" fs-5 fw-semibold">
                <span className="clrgreen" style={{ color: '#23674B' }}>
                  “Personal Finance is <br />  90% personal and 10% finance”</span>
              </h2>
            </div>
            {/*rgb(37, 201, 165) for text line  */}
            {/* #E6FAF2 center card */}
            {/* #E3F3ED cards */}

            <div className="w-full space-y-4 mt-4">
              <div className="  bg-opacity-25 shadow-md rounded-lg py-4 px-3 d-flex align-items-center rounded-3 mb-3 w-75 mx-auto"
                style={{ backgroundColor: "#E3F3ED" }}
              >

                <p className="text-black m-0 text-center w-100 refer">
                  Understanding key aspects of your background<br />
                  allows for a personalized financial plan.
                </p>
              </div>

              <div
                className="shadow-md rounded-lg py-4 px-3 d-flex align-items-center rounded-3 mb-3 w-75 mx-auto"
                style={{ backgroundColor: "#DEE5F8" }}
              >
                <p className="text-black m-0 text-center w-100 refer">
                  Imagine a doctor prescribing medicine without<br />
                  assessing your health—it wouldn’t be effective.
                </p>
              </div>

              <div className="  bg-opacity-25 shadow-md rounded-lg py-4 px-3 d-flex align-items-center rounded-3 w-75 mx-auto"
                style={{ backgroundColor: "#E3F3ED" }}
              >
                <p className="text-black m-0 text-center w-100 refer">
                  This ensures that the plan for your goal<br />
                  achievement aligns with your unique journey.
                </p>
              </div>
            </div>




          </div>


          {/* here the fields */}

          <div className="col-lg-6 col-md-12">
            <div
              className="d-flex align-items-end"
              style={{ flexDirection: "column" }}
            >
              <div className="row mt-2 mt-md-0">
                <div className="col-2">
                  <span>
                    <img
                      src="assets/images/profile-icon.png"
                      alt=""
                      className="float-end"
                    />
                  </span>
                </div>
                <div className="col-10">
                  <p className="fs-21">
                    For future correspondence, you would like to be called as
                    <input
                      type="text"
                      className="clrgreen fs-21-700  ps-3 moinput text-capitalize"
                      value={(name)}
                      onChange={(e) => {
                        setName(capitalizeText(e.target.value));

                      }}
                      onBlur={saveUserAbout}
                      placeholder="Name"
                      style={{
                        border: "none",
                        borderBottom: "1px solid green",
                        width: `${name?.length + 2}ch`,
                        paddingLeft: "1rem",
                        minWidth: "10ch",
                      }}
                    />
                  </p>
                </div>


                {/* for location */}
                <div className="col-2">
                  <span>
                    <img
                      src="assets/images/2.png"
                      alt=""
                      className="float-end"
                    />
                  </span>
                </div>
                <div className="col-10">
                  <p className="fs-21">
                    At the age of <span className="clrgreen fs-21-700">
                      {calculateAge(clientData.dob)}
                      {/* Years Old */}
                    </span>{" "} and living in{" "}
                    <input
                      type="text"
                      className="clrgreen fs-21-700 moinput text-capitalize"
                      value={city}
                      onChange={(e) => { setCity(e.target.value); }}
                      onBlur={saveUserAbout}
                      placeholder="City"
                      style={{
                        border: "none",
                        borderBottom: "1px solid green",
                        width: `${city?.length + 2}ch`,
                        paddingLeft: "1rem",
                        minWidth: "6ch",
                      }}
                    />{" "}
                    , staying on top of your finances helps you maintain the lifestyle you enjoy while staying financially secure.
                  </p>
                </div>
                <div className="col-2">
                  <span>
                    <img
                      src="assets/images/icon-2.png"
                      alt=""
                      className="float-end"
                    />
                  </span>
                </div>

                <div className="col-10">
                  <p className="fs-21 m-0">
                    You are{" "}
                    <select
                      className="clrgreen fs-21-700  ps-3 moinput text-capitalize"
                      value={maritalStatus}
                      onChange={(e) => { setMaritalStatus(e.target.value); }}
                      onBlur={saveUserAbout}
                      style={{
                        border: "none",
                        borderBottom: "1px solid green",
                        width: `${maritalStatus?.length + 4}ch`,
                        paddingLeft: "1rem",
                        minWidth: "10ch",
                      }}
                    >

                      <option value="">Select</option>
                      <option value="single">Single</option>
                      <option value="married">Married</option>
                    </select>
                    {maritalStatus === "married" && (
                      <>
                        , your spouse’s name is{" "}
                        <input
                          type="text"
                          className="clrgreen fs-21-700  ps-3 moinput text-capitalize"
                          placeholder="Spouse"
                          value={(spouseName)}
                          onChange={(e) => { setSpouseName(capitalizeText(e.target.value)); }}
                          onBlur={saveUserAbout}
                          style={{
                            border: "none",
                            borderBottom: "1px solid green",
                            width: `${spouseName?.length + 3}ch`,
                            paddingLeft: "1rem",
                            minWidth: "10ch",
                          }}
                        />

                        {/* spaouse Work start */}




                        <p className="fs-21 d-inline ">{" "}
                          {clientData.gender === "M" ? "she" : "he"} is
                          <select
                            className="clrgreen fs-21-700  ps-3 moinput "
                            value={spouseWork}
                            onChange={(e) => { setSpouseWork(e.target.value); }}
                            onBlur={saveUserAbout}
                            style={{
                              border: "none",
                              borderBottom: "1px solid green",
                              width: `${spouseWork?.length + 5}ch`,
                              paddingLeft: "2rem",
                              minWidth: "10ch",
                            }}
                          >
                            <option value="">Select</option>
                            <option value="Salaried"> Salaried</option>
                            <option value="Self Employed"> Self Employed</option>
                            <option value="Doctor">a Doctor</option>
                            <option value="CA">
                              a Chartered Accountant
                            </option>
                            <option value="Lawyer">a Lawyer</option>
                            <option value="Consultant">a Consultant</option>
                            <option value="Homemaker">a Homemaker</option>
                            <option value="Retired"> Retired</option>
                            <option value="Government Employee">
                              {" "}
                              Government Employee
                            </option>
                          </select>
                          {(spouseWork === "Salaried" ||
                            spouseWork === "Doctor" ||
                            spouseWork === "Government Employee") && (
                              <>
                                and works with{" "}
                                <input
                                  type="text"
                                  className="clrgreen fs-21-700  ps-3 moinput text-capitalize"
                                  value={(spouseCompany)}
                                  onChange={(e) => { setSpouseCompany(capitalizeText(e.target.value)); }}
                                  onBlur={saveUserAbout}
                                  style={{
                                    border: "none",
                                    borderBottom: "1px solid green",
                                    width: `${spouseCompany?.length + 2}ch`,
                                    paddingLeft: "1rem",
                                    minWidth: "10ch",
                                  }}
                                  placeholder="Company Name"
                                />
                                as{" "}
                                <input
                                  type="text"
                                  className="clrgreen fs-21-700  ps-3 moinput text-capitalize"
                                  value={(spouseJobTitle)}
                                  style={{
                                    border: "none",
                                    borderBottom: "1px solid green",
                                    width: `${spouseJobTitle?.length + 2}ch`,
                                    paddingLeft: "1rem",
                                    minWidth: "10ch",
                                  }}
                                  onChange={(e) => { setSpouseJobTitle(capitalizeText(e.target.value)); }}
                                  onBlur={saveUserAbout}
                                  placeholder="Designation"
                                />
                                .
                              </>
                            )}
                          {(spouseWork === "CA" || spouseWork === "Lawyer") && (
                            <>
                              ,and her firm's name is{" "}
                              <input
                                type="text"
                                className="clrgreen fs-21-700  ps-3 moinput text-capitalize"
                                value={(isSpouseFirmName)}
                                onChange={(e) => { setIsSpouseFirmName(capitalizeText(e.target.value)); }}
                                onBlur={saveUserAbout}
                                style={{
                                  border: "none",
                                  borderBottom: "1px solid green",
                                  width: `${isSpouseFirmName?.length + 2}ch`,
                                  paddingLeft: "1rem",
                                  minWidth: "10ch",
                                }}
                                placeholder=""
                              />{" "}
                              .
                            </>
                          )}
                          {spouseWork === "Self Employed" && (
                            <>
                              ,and her company name is{" "}
                              <input
                                type="text"
                                className="clrgreen fs-21-700  ps-3 moinput text-capitalize"
                                value={(spouseCompany)}
                                onChange={(e) => { setSpouseCompany(capitalizeText(e.target.value)); }}
                                onBlur={saveUserAbout}
                                style={{
                                  border: "none",
                                  borderBottom: "1px solid green",
                                  width: `${spouseCompany?.length + 2}ch`,
                                  paddingLeft: "1rem",
                                  minWidth: "10ch",
                                }}
                                placeholder=""
                              />{" "}
                              .
                            </>
                          )}
                          {spouseWork === "Consultant" && (
                            <>
                              {" "}
                              ,in the field of{" "}
                              <input
                                type="text"
                                className="clrgreen fs-21-700  ps-3 moinput text-capitalize"
                                value={(isSpouseConsultant)}
                                onChange={(e) => { setIsSpouseConsultant(capitalizeText(e.target.value)); }}
                                onBlur={saveUserAbout}
                                style={{
                                  border: "none",
                                  borderBottom: "1px solid green",
                                  width: `${isSpouseConsultant?.length + 2}ch`,
                                  paddingLeft: "1rem",
                                  minWidth: "10ch",
                                }}
                                placeholder=""
                              />{" "}
                              .
                            </>
                          )}
                          {spouseWork === "Retired" && (
                            <>
                              {" "}
                              from{" "}
                              <input
                                type="text"
                                className="clrgreen fs-21-700  ps-3 moinput text-capitalize"
                                value={(spouseCompany)}
                                onChange={(e) => { setSpouseCompany(capitalizeText(e.target.value)); }}
                                onBlur={saveUserAbout}
                                style={{
                                  border: "none",
                                  borderBottom: "1px solid green",
                                  width: `${spouseCompany?.length + 2}ch`,
                                  paddingLeft: "1rem",
                                  minWidth: "10ch",
                                }}
                                placeholder=""
                              />{" "}
                              in{" "}
                              <input
                                type="text"
                                className="clrgreen fs-21-700  ps-3 moinput text-capitalize"
                                value={isSpouseRetiredYear}
                                onChange={(e) => { setIsSpouseRetiredYear(e.target.value); }}
                                onBlur={saveUserAbout}
                                style={{
                                  border: "none",
                                  borderBottom: "1px solid green",
                                  width: `${isSpouseRetiredYear?.length + 2}ch`,
                                  paddingLeft: "1rem",
                                  minWidth: "10ch",
                                }}
                                placeholder=""
                              />{" "}
                              .
                            </>
                          )}
                        </p>

                        {/* spaouse Work End */}
                      </>
                    )}
                  </p>
                </div>

                <div className="col-2 mt-4">
                  <span>
                    <img
                      src="assets/images/kids-icon.png"
                      alt=""
                      className="float-end"
                    />
                  </span>
                </div>

                <div className="col-10 mt-4">
                  <p className="fs-21">
                    You have{" "}
                    <span className="clrgreen fs-21-700">
                      {children.length} Child{children.length > 1 ? "ren" : ""}
                    </span>
                  </p>

                  <div>
                    {children.length > 0 &&
                      children.map((child, index) => (
                        <div className="row mt-3" key={index}>
                          <div className="col-md-5 col-4">
                            <input
                              type="text"
                              name={`childName${index}`}
                              value={(child.name || "")}
                              placeholder="Child Name"
                              required
                              className="fs-21-700 clrgreen w-100 ps-3 moinput1 fs-21 text-capitalize"
                              style={{
                                border: "none",
                                borderBottom: "1px solid green",
                                outline: "none",
                              }}
                              onChange={(e) => {
                                handleAdditionalChildrenChange(index, "name")(e);
                              }}
                              onBlur={saveUserAbout}

                            />
                          </div>

                          <div className="col-md-5 col-6">
                            <DatePicker
                              selected={child.dob ? new Date(child.dob) : null}
                              onChange={(date) => {
                                handleAdditionalChildrenChange(index, "dob")({
                                  target: { value: date ? format(date, "yyyy-MM-dd") : "" }
                                });
                              }}
                              onBlur={saveUserAbout}
                              className="fs-21-700 clrgreen w-100 ps-3 moinput1 fs-21 react-datepicker-input"
                              style={{
                                border: "none",
                                borderBottom: "1px solid green",
                                outline: "none",
                              }}
                              dateFormat="yyyy-MM-dd"
                              placeholderText="Select Date"
                              showYearDropdown
                              scrollableYearDropdown
                              yearDropdownItemNumber={50}
                            />
                          </div>

                          <div className="col-md-2 col-2">
                            <MdOutlineCancel
                              className="text-danger cursor-pointer fs-5"
                              onClick={() => { handleDeleteChildren(index) }}
                            />
                          </div>
                        </div>
                      ))}
                  </div>

                  <Button
                    size="sm"
                    variant="success"
                    className="my-3"
                    onClick={handleAddMoreChild}
                  >
                    Add Child
                  </Button>
                </div>
                {/* main Work start */}
                <div className="col-2">
                  <span>
                    <img
                      src="assets/images/bags-icon.png"
                      alt=""
                      className="float-end"
                    />
                  </span>
                </div>


                <div className="col-10">
                  <p className="fs-21">
                    You are
                    <select
                      className="clrgreen fs-21-700  ps-3 moinput "
                      value={work}
                      onChange={(e) => { setWork(e.target.value); }}
                      onBlur={saveUserAbout}
                      // style={{
                      //   border: "none",
                      //   borderBottom: "1px solid green",
                      //   width: `${work?.length + 5}ch`,
                      //   paddingLeft: "2rem",
                      //   minWidth: "10ch",
                      // }}
                      style={{
                        border: "none",
                        borderBottom: "1px solid green",
                        paddingLeft: "2rem",
                        minWidth: "20ch", // enough for "Government Employee"
                        width: "auto", // fit content
                      }}

                    >
                      <option value="">Select</option>
                      <option value="Salaried"> Salaried</option>
                      <option value="Self Employed"> Self Employed</option>
                      <option value="Doctor">a Doctor</option>
                      <option value="CA">
                        a Chartered Accountant
                      </option>
                      <option value="Lawyer">a Lawyer</option>
                      <option value="Consultant">a Consultant</option>
                      <option value="Homemaker">a Homemaker</option>
                      <option value="Retired"> Retired</option>
                      <option value="Government Employee">
                        {" "}
                        Government Employee
                      </option>
                    </select>
                    {(work === "Salaried" ||
                      work === "Doctor" ||
                      work === "Government Employee") && (
                        <>
                          and works with{" "}
                          <input
                            type="text"
                            className="clrgreen fs-21-700  ps-3 moinput"
                            value={(company)}
                            onChange={(e) => { setCompany(e.target.value); }}
                            onBlur={saveUserAbout}
                            style={{
                              border: "none",
                              borderBottom: "1px solid green",
                              width: `${company?.length + 2}ch`,
                              paddingLeft: "1rem",
                              minWidth: "10ch",
                            }}
                            placeholder="Company Name"
                          />
                          as{" "}
                          <input
                            type="text"
                            className="clrgreen fs-21-700  ps-3 moinput text-capitalize"
                            value={(jobTitle)}
                            style={{
                              border: "none",
                              borderBottom: "1px solid green",
                              width: `${jobTitle?.length + 2}ch`,
                              paddingLeft: "1rem",
                              minWidth: "10ch",
                            }}
                            onChange={(e) => { setJobTitle(capitalizeText(e.target.value)); }}
                            onBlur={saveUserAbout}
                            placeholder="Designation"
                          />
                          .
                        </>
                      )}
                    {(work === "CA" || work === "Lawyer") && (
                      <>
                        ,and your firm's name is{" "}
                        <input
                          type="text"
                          className="clrgreen fs-21-700  ps-3 moinput text-capitalize"
                          value={(isFirmName)}
                          onChange={(e) => { setIsFirmName(capitalizeText(e.target.value)); }}
                          onBlur={saveUserAbout}
                          style={{
                            border: "none",
                            borderBottom: "1px solid green",
                            width: `${company?.length + 2}ch`,
                            paddingLeft: "1rem",
                            minWidth: "10ch",
                          }}
                          placeholder=""
                        />{" "}
                        .
                      </>
                    )}
                    {work === "Self Employed" && (
                      <>
                        ,and your company name is{" "}
                        <input
                          type="text"
                          className="clrgreen fs-21-700  ps-3 moinput text-capitalize"
                          value={(company)}
                          onChange={(e) => { setCompany(capitalizeText(e.target.value)); }}
                          onBlur={saveUserAbout}
                          style={{
                            border: "none",
                            borderBottom: "1px solid green",
                            width: `${company?.length + 2}ch`,
                            paddingLeft: "1rem",
                            minWidth: "10ch",
                          }}
                          placeholder=""
                        />{" "}
                        .
                      </>
                    )}
                    {work === "Consultant" && (
                      <>
                        {" "}
                        ,in the field of{" "}
                        <input
                          type="text"
                          className="clrgreen fs-21-700  ps-3 moinput text-capitalize"
                          value={(isConsultant)}
                          onChange={(e) => { setIsConsultant(capitalizeText(e.target.value)); }}
                          onBlur={saveUserAbout}
                          style={{
                            border: "none",
                            borderBottom: "1px solid green",
                            width: `${isConsultant?.length + 2}ch`,
                            paddingLeft: "1rem",
                            minWidth: "10ch",
                          }}
                          placeholder=""
                        />{" "}
                        .
                      </>
                    )}
                    {work === "Retired" && (
                      <>
                        {" "}
                        from{" "}
                        <input
                          type="text"
                          className="clrgreen fs-21-700  ps-3 moinput text-capitalize"
                          value={(company)}
                          onChange={(e) => { setCompany(capitalizeText(e.target.value)); }}
                          onBlur={saveUserAbout}
                          style={{
                            border: "none",
                            borderBottom: "1px solid green",
                            width: `${company?.length + 2}ch`,
                            paddingLeft: "1rem",
                            minWidth: "10ch",
                          }}
                          placeholder=""
                        />{" "}
                        in{" "}
                        <input
                          type="text"
                          className="clrgreen fs-21-700  ps-3 moinput text-capitalize"
                          value={isRetiredYear}
                          onChange={(e) => { setIsRetiredYear(e.target.value); }}
                          onBlur={saveUserAbout}
                          style={{
                            border: "none",
                            borderBottom: "1px solid green",
                            width: `${isRetiredYear?.length + 2}ch`,
                            paddingLeft: "1rem",
                            minWidth: "10ch",
                          }}
                          placeholder=""
                        />{" "}
                        .
                      </>
                    )}
                  </p>
                </div>
                {/* main Work End */}



              </div>
            </div>
          </div>



        </div>
        <div className="my-4 w-75 mx-auto">

          <ProgressBarTimer />
        </div>
      </div>
      <div className="container mb-4">
        <div className="row ">
          <div className="col text-end">
            <a href="javascript:void(0);" onClick={handleBack}>
              <img
                className="arrow_next1"
                src="assets/images/left-arrowpng.png"
                alt=""
              />
            </a>
            <a href="javascript:void(0);" className="ms-1" onClick={handleNext}>
              <img
                className="arrow_next"
                src="assets/images/right-arrow.svg"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default FinancialPlan;
